import { NavigateOptions, To, useNavigate } from 'react-router-dom';

import {
  mapSidebarKeyToRegex,
  sidebarKeys,
} from '~/components/sidebar/utils/navigation-utils';
import { useBreadcrumbs } from '~/stores/use-breadcrumbs/useBreadcrumbs';
import {
  ActionModal,
  useScreenerActionsStore,
} from '~/views/screener/use-screener-actions/useScreenerActions';
import { useScreenerStore } from '~/views/screener/use-screener-store/useScreenerStore';

export type NavigateTerminalProps = {
  to?: To;
  options?: NavigateOptions;
  navigateFn?: () => void;
  crumb?: {
    label: string;
    isSidebar?: boolean;
    isAccessibleFromSideBar?: boolean;
    themeId?: string;
    assetTag?: string;
  };
};

export const useTerminalNavigate = () => {
  const navigate = useNavigate();
  const { handleLocationChange } = useBreadcrumbs(state => ({
    handleLocationChange: state.handleLocationChange,
  }));
  const { shouldPromptUnsavedChanges, resetActiveFilterOptions } =
    useScreenerStore(state => ({
      shouldPromptUnsavedChanges: state.shouldPromptUnsavedChanges(),
      resetActiveFilterOptions: state.resetActiveFilterOptions,
    }));
  const { setActiveModal } = useScreenerActionsStore(state => ({
    setActiveModal: state.setActiveModal,
  }));

  const navigateTerminal = ({
    to,
    navigateFn,
    crumb,
  }: NavigateTerminalProps) => {
    const navigation = () => {
      handleLocationChange({ to, crumb, navigateFn });
      to ? navigate(to) : navigateFn?.();
    };

    const isOnScreenerScreen = mapSidebarKeyToRegex[sidebarKeys.screener].test(
      location.pathname
    );
    const isNavigatingToScreener = crumb?.label
      .toLowerCase()
      .includes(sidebarKeys.screener);

    const shouldDisplayUnsavedChanges =
      isOnScreenerScreen &&
      !isNavigatingToScreener &&
      shouldPromptUnsavedChanges;

    if (shouldDisplayUnsavedChanges) {
      setActiveModal({
        activeModal: ActionModal.UnsavedChanges,
        nextActions: [resetActiveFilterOptions, navigation],
      });
    } else {
      navigation();
    }
  };

  return navigateTerminal;
};
